import React from 'react'

export const LinkedinIcon = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      className={className}
    >
      <path
        d="M13.32 0H1.8C0.8064 0 0 0.749611 0 1.67324V12.382C0 13.3056 0.8064 14.0552 1.8 14.0552H13.32C14.3136 14.0552 15.12 13.3056 15.12 12.382V1.67324C15.12 0.749611 14.3136 0 13.32 0ZM4.68 5.35437V11.7127H2.52V5.35437H4.68ZM2.52 3.50376C2.52 3.03526 2.952 2.67718 3.6 2.67718C4.248 2.67718 4.6548 3.03526 4.68 3.50376C4.68 3.97227 4.2768 4.35042 3.6 4.35042C2.952 4.35042 2.52 3.97227 2.52 3.50376ZM12.6 11.7127H10.44C10.44 11.7127 10.44 8.61384 10.44 8.3662C10.44 7.6969 10.08 7.02761 9.18 7.01422H9.1512C8.28 7.01422 7.92 7.70359 7.92 8.3662C7.92 8.67073 7.92 11.7127 7.92 11.7127H5.76V5.35437H7.92V6.21106C7.92 6.21106 8.6148 5.35437 10.0116 5.35437C11.4408 5.35437 12.6 6.26795 12.6 8.11856V11.7127Z"
        fill="black"
      />
    </svg>
  )
}
